function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRadlad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 180,
    height: 180,
    rx: 36,
    fill: "#9B8CAE",
    style: {
      fill: "rgb(155, 140, 174)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 52,
    width: 68,
    height: 85,
    rx: 5,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "108,52 108,72 128,72",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "108,52 128,72",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 80,
    x2: 100,
    y2: 80,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.6,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 91,
    x2: 118,
    y2: 91,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.6,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 102,
    x2: 110,
    y2: 102,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.6,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 113,
    x2: 118,
    y2: 113,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.6,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134,
    cy: 120,
    rx: 16,
    ry: 10,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 120,
    r: 5,
    fill: "white",
    opacity: 0.9,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 120,
    r: 2,
    fill: "#9B8CAE",
    style: {
      fill: "rgb(155, 140, 174)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "118,108 114,108 114,112",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "150,108 154,108 154,112",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "118,132 114,132 114,128",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "150,132 154,132 154,128",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 162,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "white",
    letterSpacing: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 13,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "RAD / LAD"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRadlad);
export default __webpack_public_path__ + "static/media/Logo_radlad.81d51ae84704469ec046da27cd7e97f6.svg";
export { ForwardRef as ReactComponent };